export interface EnvironmentConfig {
  apiBaseUrl: string;
  environment: string;
  appName: string;
  version: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 
    (process.env.NODE_ENV === 'production' 
      ? 'https://api.zappme.net/api/v2'
      : 'http://localhost:5002/api/v2');

  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development';
  
  return {
    apiBaseUrl,
    environment,
    appName: process.env.REACT_APP_APP_NAME || 'ZApp Admin',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    isDevelopment: environment === 'development',
    isProduction: environment === 'production',
  };
};

export const config = getEnvironmentConfig();

// Debug logging in development
if (config.isDevelopment) {
  console.log('🔧 Environment Configuration:', config);
}

export default config;
